import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import { addNotification } from 'actions/NotificationsActions';
import { deleterDispatchHelper } from 'actions/DeleterActions';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import SimplePrompt from 'components/layout/SimplePrompt';

import List from 'components/List';

import WhiteLabelNew from 'components/modals/WhiteLabelNew';

import may from 'js/security';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

class WhiteLabel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
    };
  }

  showNew = () => {
    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };

  handleRowClick = detailsUrl => {
    const { history } = this.props;
    history.push(detailsUrl);
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
    } = this.props;

    return (
      <Breadcrumb
        crumbs={[
          { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
          { link: null, name: messages.white_label_projects },
        ]}
        className="p-t-0"
      />
    );
  };

  handleRemoveClick = (e, whiteLabelId) => {
    e.preventDefault();
    e.stopPropagation();

    const { deleteDataPush } = this.props;
    deleteDataPush(whiteLabelId);
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      appIntl,
      history,
      formStatus,
      doNotify,
    } = this.props;

    // new white label project was created
    if (!formStatus.pending && prevProps.formStatus.pending && !formStatus.hasError) {
      doNotify(1, messages.white_label_saved);
      history.push(`${appIntl.urlPrefix}account/settings/whiteLabel/${formStatus.response.id}`);
    }
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      list,
      user,
    } = this.props;
    const { showNew } = this.state;

    const columns = [messages.name, messages.domain, messages.actions];
    const tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const whiteLabel = list.data.list[i];
      const { id, domains, name } = whiteLabel;

      const detailsUrl = appIntl.urlPrefix + 'account/settings/whiteLabel/' + id;

      tBody.push(
        <tr key={i} class="clickable" onClick={() => this.handleRowClick(detailsUrl)}>
          <td class="v-align-middle">{name || '-'}</td>
          <td class="v-align-middle">{domains ? domains.join(', ') : '-'}</td>
          <td class="v-align-middle text-right">
            <Link to={detailsUrl} class="btn-rounded m-r-10 btn btn-sm btn-default">
              <i class="fa fa-pencil-alt" /> {messages.edit}
            </Link>
            {may('ROLE_SUPERADMIN', user.roles) ? (
              <SimplePrompt onSuccess={e => this.handleRemoveClick(e, id)} />
            ) : null}
          </td>
        </tr>
      );
    }

    const resultTable = list.pending ? (
      <Loader />
    ) : (
      <Table responsive hover>
        <thead>
          <tr>
            {columns.map((column, i) => {
              return (
                <th key={i} class={column === messages.actions ? 'text-right' : ''}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );

    return (
      <DocMeta tags={generateMetaTags(messages.meta.white_label_projects)}>
        <List
          listName="whiteLabel"
          url="/api/whitelabels.json"
          urlData={{ filters: may('ROLE_SUPERADMIN', user.roles) ? {} : { isCommunity: false } }}
          list={list}
          title={messages.white_label_projects}
          iconClass="fa fa-asterisk"
          showNew={may('ROLE_SUPERADMIN', user.roles)}
          newText={messages.add_white_label}
          newAction={this.showNew}
          showSearch={may('ROLE_SUPERADMIN', user.roles)}
          sortOptions={['relevance,desc', 'name,asc', 'cdate,desc']}
          breadcrumb={this.getBreadcrumb()}
        >
          {resultTable}

          <div id="white-label-new">
            <WhiteLabelNew show={showNew} close={this.closeNew} />
          </div>
        </List>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.whiteLabel,
    user: state.login.user,
    formStatus: state.formStatus.whiteLabelNew,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    deleteDataPush: whiteLabelId => {
      deleterDispatchHelper('whiteLabel', '/api/whitelabels/' + whiteLabelId + '.json', dispatch);
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(WhiteLabel)
  )
);
